import { translate as t } from '@thoughtspot/i18n';
import DOMPurify from 'dompurify';
import Joi from 'joi';
const labelTranslationschema = Joi.object({
    msgIds: Joi.array()
        .items(Joi.string()
        .max(120)
        .trim())
        .required()
        .allow()
        .empty(),
});
export const validateGetLabelTranslationsPayloadObject = (object) => {
    try {
        Joi.assert(object, labelTranslationschema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
};
export const getTranslatedValue = (msgIds) => {
    const result = {};
    msgIds.forEach((msgId) => {
        const sanitizedMsgId = DOMPurify.sanitize(msgId);
        let msgValue = t(sanitizedMsgId);
        if (msgValue === sanitizedMsgId) {
            msgValue = '';
        }
        result[msgId] = {
            msgId,
            msgValue,
        };
    });
    return result;
};
//# sourceMappingURL=utils.js.map